export default __webpack_public_path__ + "static/media/07.304c5d35.jpg";